import React, {useState} from "react";
import './MobileCard.css';
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {colors} from "../../../shared/colors";
import {withRouter} from "react-router-dom";

const MobileCard = (props) => {
    const [elevation, setElevation] = useState(5);

    return (
        <Paper elevation={elevation}
               onMouseEnter={() => setElevation(15)}
               onMouseLeave={() => setElevation(5)}
               onClick={() => props.history.push(props.to)}
               id="mobileCard">
            <img src={props.imgSrc} alt={props.title} className="cardIcon"/>
            <Typography style={{color: colors.primary.dark}} variant="h6">
                {props.title}
            </Typography>
            <Typography variant="subtitle2">
                {props.description}
            </Typography>
        </Paper>
    )
}

export default withRouter(MobileCard);
